import {Component, Inject, OnDestroy, OnInit} from '@angular/core';
import {MAT_DIALOG_DATA, MatDialogRef} from '@angular/material/dialog';
import {FormModel} from '../../../common/components/form/models';
import {UrlService} from '../../../common/services/url/url.service';
import {SubSink} from '@Common/core/utils/subsink';
import {ListParameters} from '@Services/base/daoService';

@Component({
  selector: 'app-modal-link-form',
  templateUrl: './modal-link-form.component.html',
  styleUrls: ['./modal-link-form.component.scss']
})
export class ModalLinkFormComponent implements OnInit, OnDestroy {
  form: FormModel;
  subSink = new SubSink();
  constructor(@Inject(MAT_DIALOG_DATA) public data: FormModel,
              public dialogRef: MatDialogRef<ModalLinkFormComponent>,
              private urlSvc: UrlService
  ) {
    this._setForm(data);
  }
  private _setForm(data) {
    if (!data.url_obj || data.url_obj?.length === 0) {
      const _parameters = <ListParameters>{
        extraParams: new Map<string, string>([['form', data.id.toString()]]),
        limit: 0, offset: 0
      };
      this.subSink.sink = this.urlSvc.listItems(_parameters).subscribe(_urls => {
        this.form = data;
        this.form.url_obj = [..._urls.list];
      });
    } else {
      this.form = data;
    }
  }
  ngOnInit(): void {
  }

  ngOnDestroy(): void {
    this.subSink.unsubscribe();
  }

}
